<template>
  <el-config-provider :message="messageConfig">
    <el-container>
        <el-header id="header" style="padding: 0">
          <ApplicationBar />
        </el-header>
      <el-container id="main-container">
        <el-aside :width="`${asideWidth}px`">
          <NavigationMenu />
        </el-aside>
        <el-main style="overflow: auto; min-height: 100%; height: 100%">
          <FourOhThree v-if="$store.state.ui.fourOhThree" />
          <router-view v-else-if="sessionLoaded" />
          <el-skeleton v-else />
        </el-main>
      </el-container>
    </el-container>
  </el-config-provider>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu.vue'
import ApplicationBar from '@/components/ApplicationBar.vue'
import FourOhThree from '@/pages/FourOhThree.vue'

import {mapGetters, mapActions} from 'vuex'

const mobileBreakPointPX = 640;
const tabletBreakPointPX = 768;
const asideWidthOpened   = 300;
const asideWidthClosed   =  64;

export default {
    name: 'App',
    data: () => ({
      sessionLoaded: false,
      messageConfig: {
        duration: 20000,
        plain: true,
        placement: 'top',
        grouping: true,
        offset: 12
      }
    }),
    components: {
      NavigationMenu,
      ApplicationBar,
      FourOhThree
    },
    computed: {
      ...mapGetters('auth', ['isLoggedIn']),
      ...mapGetters('ui', [ 'isMobile', 'isTablet', 'isSidebarMinimized', 'pageTitle' ]),

      asideWidth () {
        return this.isSidebarMinimized ? asideWidthClosed : asideWidthOpened
      }
    },
    methods: {
      ...mapActions('ui', ['setIsMobile', 'setIsTablet', 'setSidebarMinimized']),
      ...mapActions('auth', ['refreshAccessToken', 'refreshAvailableResources']),

      goBack () {
        this.$router.back()
      },
      checkIsMobile () {
        return window.innerWidth < mobileBreakPointPX;
      },
      checkIsTablet () {
        return window.innerWidth < tabletBreakPointPX;
      },
      onResize() {
        this.setIsMobile ( this.checkIsMobile() );
        this.setIsTablet ( this.checkIsTablet() );

        if ( this.isTablet ) {
          this.setSidebarMinimized ( true );
        } else {
          this.setSidebarMinimized ( false );
        }
      },
      onCloseSidebarButtonClick() {
        this.setSidebarMinimized(true);
      },

      async refreshToken () {
        if ( this.isLoggedIn ) {
          this.refreshAccessToken()
        } else {
          this.refreshAvailableResources()
        }
      }
    },
    
    head() {
      return {
        title: this.pageTitle ? `${this.pageTitle}` : this.$appName
      }
    },

    created () {
      // Try to restore previous sessions when first opening the app
      this.refreshAccessToken().finally(() => {
        this.sessionLoaded = true
        setInterval( this.refreshToken, 30000 )
      })
    },

    async mounted () {
      window.addEventListener('resize', this.onResize);
      this.onResize()
    },
    watch: {
      $route() {
        if ( this.checkIsTablet() ) {
          this.setSidebarMinimized (true)
        }
      }
    }
}
</script>

<style lang="scss">

:root {
  --el-header-height: 60px;
}

#app #main-container {
  height: calc(100vh - var(--el-header-height))
}

#app aside.el-aside {
  height: 100%;
}

main.el-main {
  padding-top: 0px;
}

main.el-main > div.container > h1:first-child {
  margin-bottom: 3rem;
  position: sticky;
  top: 0px;
  z-index: 1000;
  background-color: white;
  display: block;
  width: 100%;
  margin: 0;
  padding: 1rem 0 1rem;
}

.el-form--inline {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 22px 22px;
    margin-bottom: 22px;
}

.el-form--inline .el-form-item {
    display: flex;
    flex-grow: 1;
    min-width: 200px;
    margin: 0px;
}

ul.el-upload-list.is-disabled > div.el-upload.el-upload--picture-card {
    display: none
}

.bordered-notification {
  border-width: 1px;
  border-style: solid;
  border-color: var(--el-notification-icon-color);
  $g: &;
  --el-notification-width: 500px;
  // --el-notification-padding: 28px 52px 28px 26px;
  --el-notification-title-font-size: 20px;
  // --el-notification-content-font-size: 15px;
  --el-notification-icon-size:192px;

    @each $type in (primary, success, info, warning, error) {
      &:has(.el-notification--#{$type}) {
        background-color: var(--el-color-#{$type}-light-9);
        border-color: var(--el-color-#{$type}-light-3);
        --el-notification-title-color: var(--el-color-#{$type}-dark-2);
      }
    }

  .el-notification__icon {
    position: absolute;
    top: calc(50% - var(--el-notification-icon-size)/2);
    left: calc(50% - var(--el-notification-icon-size)/2);
    z-index: 3031;
    opacity: 15%;
  }

  .el-notification__group {
    z-index: 3032;

    .el-notification__title {
      line-height: 24px;
    }
  }
}

fieldset {
    min-inline-size: min-content;
    margin-inline: 2px;
    border: 1px solid var(--el-border-color);
    border-radius: var(--el-border-radius-base);
    padding: 10px;
    padding-top: 0px;

    legend {
      float: none;
      width: auto;
      padding: 0px;
      padding-inline: 10px;
      font-size: inherit;
      margin-bottom: 5px;
    }
}
</style>